<template>
  <div data-view="businesses">
    <router-view />

    <layout-logged-frame
      :title="$t('businesses')"
      :total-count="pagination.totalItems"
    >
      <template v-slot:header-actions>
        <Can action="store" subject="business">
          <v-btn
            color="primary"
            @click="$router.push({ name: 'businesses-new' })"
          >
            <v-icon> add </v-icon>
            {{ $t('add_new_business') }}
          </v-btn>
        </Can>
      </template>

      <template v-slot:content>
        <BusinessesFilters @filter="onFilter" @clearFilters="onClearFilters" />

        <BusinessesTable
          :columns="columns"
          :items="businesses"
          :pages="totalPages"
          :pagination="pagination"
          :is-loading="isLoading"
          :on-select-item="selectItem"
          :on-update-pagination="onUpdatePagination"
          :on-change-page="onChangePage"
        >
        </BusinessesTable>
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
  import BusinessesFilters from '../../components/forms/filters/Businesses';
  import {isStr} from '@/utils';
  import columns from '../../config/businesses/columns';
  import BusinessesTable from '../../components/table/Businesses';

  export default {
    components: {
      BusinessesFilters,
      BusinessesTable
    },
    data() {
      return {
        columns,
        businesses: [],
        pagination: {
          order: 'desc' ,
          page: 1,
          rowsPerPage: 15,
          sortBy: 'created_at',
          totalItems: 0,
          search: '',
        },
        totalPages: 0,
        query: { per_page: 15 },
        isLoading: false,
      };
    },
    computed: {
      currentRoute() {
        return this.$route;
      },
    },
    watch: {
      currentRoute(to, from) {
        if (
          to.query?.status === 'success' &&
          (from.name === 'businesses-new' || from.name === 'business-details') &&
          to.name === 'businesses'
        ) {
          this.getItems(this.query);
        }
      },
    },
    methods: {
      getItems(query = {}) {
        this.isLoading = true;
        this.pagination.order = query.order;

        return this.$store
          .dispatch('businesses/getItems', query)
          .then((res) => {
            const { itemsMeta } = this.$store.getters['businesses/itemsData'];
            const { total, current_page, last_page } = itemsMeta;

            this.businesses = res.items;
            this.pagination.page = current_page;
            this.pagination.totalItems = total;
            this.totalPages = last_page;
            this.isLoading = false;

            return res;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
      selectItem(business) {
        this.$router.push({ name: 'business-details', params: { id: business.id } });
      },
      onUpdatePagination({ page, order, sortBy }) {
        const { query, pagination } = this;
        this.pagination.sortBy = isStr(sortBy) ? sortBy : pagination.sortBy;

        const nextQuery = {
          ...query,
          page,
          order,
          sort: isStr(sortBy) ? sortBy : pagination.sortBy,
        };

        this.query = nextQuery;
        this.getItems(nextQuery);
      },
      onChangePage(page) {
        const { query, pagination } = this;
        const { order, sortBy } = pagination;
        const nextQuery = {
          ...query,
          page,
          order,
          sort: sortBy,
        };

        this.query = nextQuery;
        this.getItems(nextQuery);
      },
      onFilter({ search, labels, countries, status, dates }) {
        this.query = {
          ...this.query,
          page: 1,
          search: search || undefined,
          dates: dates || undefined,
          status: status != null ? status : undefined,
          labels,
          countries,
        };

        this.getItems(this.query);
      },
      onClearFilters() {
        const { sortBy, order } = this.pagination;
        this.query = { sort: sortBy, order, per_page: 15, page: 1 };

        this.getItems(this.query);
      },
    },
  };
</script>

<style lang="scss">
@use '../../assets/styles/theme' as *;

.v-datatable {
  min-width: $table-min-width;
}
</style>
